




import Vue from "vue";
import { computed, onMounted, ref } from "@vue/composition-api";
import { SharedState } from "@/common/state";
export default Vue.extend({
  props: ["src"],
  setup(props) {
    const is_light_theme = computed(() => SharedState.theme.value === "light");
    const light_img = ref("");
    const dark_img = ref("");
    const get_light_img = (path: string) => require("../assets/" + path);
    const get_dark_img = (path: string) => require("../assets/dark/" + path);
    onMounted(() => {
      light_img.value = get_light_img(props.src as string);
      dark_img.value = get_dark_img(props.src as string);
    });

    return {
      is_light_theme,
      dark_img,
      light_img
    };
  }
});
